import {
  ALL_ASSESSMENT_HISTORY_FAILURE,
  ALL_ASSESSMENT_HISTORY_SUCCESS,
  CREATE_ALL_ASSIGNMENT_FAILURE,
  CREATE_ALL_ASSIGNMENT_SUCCESS,
  CREATE_ASSIGNMENT_FAILURE,
  CREATE_ASSIGNMENT_SUCCESS,
  CREATE_RESOURCE_FAILURE,
  CREATE_RESOURCE_SUCCESS,
  HISTORY_ASSIGNMENT_FAILURE,
  HISTORY_ASSIGNMENT_SUCCESS,
} from "./resource.actionTypes";

const initialState = {
  resource_created: null,
  allAssignment: null,
  assignment_history: null,
  allAssignmentHistoryData: null,
};

export default function createResourceReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case CREATE_RESOURCE_SUCCESS:
      return {
        ...state,
        resource_created: payload,
      };
    case CREATE_RESOURCE_FAILURE:
      return {
        ...state,
        message: "",
      };

    case HISTORY_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        assignment_history: payload,
      };
    case HISTORY_ASSIGNMENT_FAILURE:
      return {
        ...state,
        message: "",
      };

    case CREATE_ALL_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        allAssignment: payload,
      };
    case CREATE_ALL_ASSIGNMENT_FAILURE:
      return {
        ...state,
        message: "",
      };

    case ALL_ASSESSMENT_HISTORY_SUCCESS:
      return {
        ...state,
        allAssignmentHistoryData: payload,
      };
    case ALL_ASSESSMENT_HISTORY_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
